export default class DashboardComponentViewModel {
    type = null;
    id = null;
    title = null;
    grid = null;
    dataSource = null;

    constructor(component){
        this.id = component.id;
        this.title = component.title;
        this.type = component.type;
        this.grid = {
            position: {
                x: component.grid.position.x,
                y: component.grid.position.y
            },
            size: {
                x: component.grid.size.x,
                y: component.grid.size.y,
            }
        };
        this.dataSource = {
            serviceName: component.data_source.service_name,
            serviceMethod: component.data_source.service_method,
            parameters: component.data_source.parameters
        };        
    }
}